import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Category from '@mui/icons-material/Category';
import TextField from '@mui/material/TextField';
import Divider from '@mui/material/Divider';
import Progress from '../components/Loader';
// import Box from '@mui/material/Box';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import axios from 'axios';

import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import ListItem from '@mui/material/ListItem';
import List from '@mui/material/List';


const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width:550,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default function BasicModal(props) {
  const [open, setOpen] = React.useState(props.value);
  const [category, setcategory] = React.useState("none");
  const [businesstype, setbusinesstype] = React.useState("none");
  const [gender, setgender] = React.useState("none");
  const [loading, setloading] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const [personName, setPersonName] = React.useState([]);



  const names = [

    "Crops",
    "Seeds",
    "Fertilizers",
    "Machinery",
    "Irrigation"

  ];


  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setPersonName(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  const handleClose=()=>{
  setOpen(false);
  props.setfalser()
  }




  return (
    <div>
     
     
 
<Dialog fullWidth minWidth="sm" onClose={handleOpen} aria-labelledby="customized-dialog-title" open={open}>
<DialogTitle id="customized-dialog-title" onClose={handleClose} >
           {props.name +" Details"}
     
       <IconButton onClick={handleClose} style={{float:"right"}}><CloseIcon/></IconButton>
      
   </DialogTitle>
   <Divider/>
 <DialogContent>
<Box>
<>
          <List sx={{ width: '100%'}}>
                        <ListItem>
                            <ListItemText primary={props.chosen.batch} secondary="Batch Number" />
                        </ListItem>
                        <Divider />   
                        <ListItem>
                            <ListItemText primary={props.chosen.agent} secondary="Agent Name" />
                        </ListItem>
                        <Divider /> 
                        <Divider />   
                        <ListItem>
                            <ListItemText primary={props.chosen.status} secondary="Status" />
                        </ListItem>
                        <Divider /> 
                        <ListItem>
                            <ListItemText primary={props.chosen.qty} secondary="Quantity Expected" />
                        </ListItem>
                        <Divider />  
                         
                        <ListItem>
                            <ListItemText primary={props.chosen.expecteddate} secondary="Expected Supply Date" />
                        </ListItem> 
                         <Divider />  
                         
                        <ListItem>
                            <ListItemText primary={props.chosen.product && (props.chosen.product).join(", ")} secondary="Product(s)" />
                        </ListItem>
                        <Divider />  
                        <ListItem>
                            <ListItemText primary={props.chosen.qty} secondary="Quantity Pre-financed" />
                        </ListItem>
                        <Divider />  
                        
                        <ListItem>
                            <ListItemText primary={props.chosen.prefinancedate} secondary="Date Pre-financed" />
                        </ListItem>
                        <Divider /> 

                        <ListItem>
                            <ListItemText primary={props.chosen.others} secondary="Other Infomation" />
                        </ListItem>
                        <Divider /> 
                        {/* <div style={{border:"solid", borderWidth:"1px", borderColor:"gray", borderRadius:"10px"}}> */}
                        <ListItem>
                            <ListItemText primary={props.chosen.haullier} secondary="Haullier" />
                        </ListItem>
                        <Divider />  
                        <ListItem>
                            <ListItemText primary={props.chosen.vehicle} secondary="Vehicle Number" />
                        </ListItem>
                        <Divider />

                            
                                                <ListItem>
                                                    <ListItemText primary={props.chosen.rawqty} secondary="Quantity Of Raw Materials" />
                                                </ListItem>
                                                <Divider />  
                                                <ListItem>
                                                    <ListItemText primary={props.chosen.finishqty+ " "+props.chosen.unitqty} secondary="Quantity Of Finished goods" />
                                                </ListItem>
                                                <Divider />   
                
                        <ListItem>
                            <ListItemText primary={props.chosen.qtyreceived?props.chosen.qtyreceived:0 + " "+props.chosen.unitqty} secondary="Quantity Received By Haullier" />
                        </ListItem>
                        <Divider /> 
                        <ListItem>
                            <ListItemText primary={props.chosen.waybil} secondary="Waybill Number" />
                        </ListItem>
                        <Divider />  
                        <ListItem>
                            <ListItemText primary={props.chosen.datedispatched} secondary="Date Dispatched" />
                        </ListItem>
                        <Divider /> 
                      
                        <ListItem>
                            <ListItemText primary={props.chosen.warehousereceived} secondary="Warehouse to be Stored" />
                        </ListItem>
                      
                        <Divider /> 
                        

                    </List>
        </>

 </Box>
 </DialogContent>
 {/* <Divider/> */}
  
</Dialog>


</div>



  );
}
